export const drawerModal = (id) => {
    return {
        visible: false,
        item: {},

        show(options) {
            this.item = options;
            this.visible = true;
        },

        toggle() {
            this.visible = !this.visible;
        },

        init() {
            window.addEventListener(`drawer:${id}`, (e) => {
                this.show(e.detail);
            });
        },
    };
};

window.showDrawerModal = (drawerId, item = {}) => {
    window.dispatchEvent(
        new CustomEvent(`drawer:${drawerId}`, {
            detail: item,
        }),
    );
};
